import { render, staticRenderFns } from "./JournalTablePage.vue?vue&type=template&id=1c08cf42&scoped=true&"
import script from "./JournalTablePage.vue?vue&type=script&lang=js&"
export * from "./JournalTablePage.vue?vue&type=script&lang=js&"
import style0 from "./JournalTablePage.vue?vue&type=style&index=0&id=1c08cf42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c08cf42",
  null
  
)

export default component.exports